// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type CreateDocumentCollectionFromTemplateMutationVariables = Types.Exact<{
  input: Types.CreateDocumentCollectionFromTemplateInput;
}>;


export type CreateDocumentCollectionFromTemplateMutation = { __typename?: 'Mutation', createDocumentCollectionFromTemplate: { __typename?: 'DocumentCollection', id: string, name: string, icon: Types.DocumentCollectionIcon, createdAt: any, updatedAt: any, documentFieldsCount: number } };

export type SaveDocumentCollectionAsTemplateMutationVariables = Types.Exact<{
  input: Types.SaveDocumentCollectionAsTemplateInput;
}>;


export type SaveDocumentCollectionAsTemplateMutation = { __typename?: 'Mutation', saveDocumentCollectionAsTemplate: { __typename?: 'CollectionTemplate', id: string, scope: Types.CollectionTemplateScope, name: string, description: string, icon: Types.DocumentCollectionIcon, fields: Array<{ __typename?: 'CollectionTemplateField', name: string, kind: Types.DocumentFieldKind }> } };

export type DeleteCollectionTemplateMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteCollectionTemplateMutation = { __typename?: 'Mutation', deleteCollectionTemplate: boolean };


export const CreateDocumentCollectionFromTemplateDocument = gql`
    mutation CreateDocumentCollectionFromTemplate($input: CreateDocumentCollectionFromTemplateInput!) {
  createDocumentCollectionFromTemplate(input: $input) {
    id
    name
    icon
    createdAt
    updatedAt
    documentFieldsCount
  }
}
    `;

/**
 * __useCreateDocumentCollectionFromTemplateMutation__
 *
 * To run a mutation, you first call `useCreateDocumentCollectionFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentCollectionFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentCollectionFromTemplateMutation, { data, loading, error }] = useCreateDocumentCollectionFromTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentCollectionFromTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDocumentCollectionFromTemplateMutation, CreateDocumentCollectionFromTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDocumentCollectionFromTemplateMutation, CreateDocumentCollectionFromTemplateMutationVariables>(CreateDocumentCollectionFromTemplateDocument, options);
      }
export type CreateDocumentCollectionFromTemplateMutationHookResult = ReturnType<typeof useCreateDocumentCollectionFromTemplateMutation>;
export type CreateDocumentCollectionFromTemplateMutationResult = ApolloReactCommon.MutationResult<CreateDocumentCollectionFromTemplateMutation>;
export const SaveDocumentCollectionAsTemplateDocument = gql`
    mutation SaveDocumentCollectionAsTemplate($input: SaveDocumentCollectionAsTemplateInput!) {
  saveDocumentCollectionAsTemplate(input: $input) {
    id
    scope
    name
    description
    icon
    fields {
      name
      kind
    }
  }
}
    `;

/**
 * __useSaveDocumentCollectionAsTemplateMutation__
 *
 * To run a mutation, you first call `useSaveDocumentCollectionAsTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDocumentCollectionAsTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDocumentCollectionAsTemplateMutation, { data, loading, error }] = useSaveDocumentCollectionAsTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDocumentCollectionAsTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveDocumentCollectionAsTemplateMutation, SaveDocumentCollectionAsTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveDocumentCollectionAsTemplateMutation, SaveDocumentCollectionAsTemplateMutationVariables>(SaveDocumentCollectionAsTemplateDocument, options);
      }
export type SaveDocumentCollectionAsTemplateMutationHookResult = ReturnType<typeof useSaveDocumentCollectionAsTemplateMutation>;
export type SaveDocumentCollectionAsTemplateMutationResult = ApolloReactCommon.MutationResult<SaveDocumentCollectionAsTemplateMutation>;
export const DeleteCollectionTemplateDocument = gql`
    mutation DeleteCollectionTemplate($id: ID!) {
  deleteCollectionTemplate(id: $id)
}
    `;

/**
 * __useDeleteCollectionTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteCollectionTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollectionTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCollectionTemplateMutation, { data, loading, error }] = useDeleteCollectionTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCollectionTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCollectionTemplateMutation, DeleteCollectionTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCollectionTemplateMutation, DeleteCollectionTemplateMutationVariables>(DeleteCollectionTemplateDocument, options);
      }
export type DeleteCollectionTemplateMutationHookResult = ReturnType<typeof useDeleteCollectionTemplateMutation>;
export type DeleteCollectionTemplateMutationResult = ApolloReactCommon.MutationResult<DeleteCollectionTemplateMutation>;